import { render, staticRenderFns } from "./LatestSuppliersListSection.vue?vue&type=template&id=325f110c&"
import script from "./LatestSuppliersListSection.vue?vue&type=script&lang=js&"
export * from "./LatestSuppliersListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports